import type { SummaryDataField } from '../types';

export const summaryFieldOptions: {
  value: SummaryDataField;
  label: string;
}[] = [
  { value: 'loansAmount', label: 'Loans amount' },
  { value: 'salesAmount', label: 'Sales amount' },
  { value: 'loansCount', label: 'Number of loans' },
];
